import { render } from "./PageLink.vue?vue&type=template&id=480aa6c8"
import script from "./PageLink.vue?vue&type=script&lang=js"
export * from "./PageLink.vue?vue&type=script&lang=js"

import "./PageLink.vue?vue&type=style&index=0&id=480aa6c8&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__